'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Icon = require('@narvar/nth-bit-icon-button');
var XIcon = require('@narvar/nth-bit-icon-x');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Icon__default = /*#__PURE__*/_interopDefaultLegacy(Icon);
var XIcon__default = /*#__PURE__*/_interopDefaultLegacy(XIcon);

const Dismiss = ({
  onClick
}) => {
  return /*#__PURE__*/React__default["default"].createElement(Icon__default["default"], {
    onClick: onClick,
    s: {
      padding: 0
    },
    ariaLabel: "close"
  }, /*#__PURE__*/React__default["default"].createElement(XIcon__default["default"], {
    s: {
      fill: '#9e9e9e'
    }
  }));
};

exports["default"] = Dismiss;
